// src/stores/testCustomerMarkersStore.js
//
// Listens to the configured test names (globalSettings/testCustomers.markers; Settings → Test Customers) and hands
// them to the browser's one test-customer check, src/utils/testCustomer.js. Live: a saved change reaches every open
// tab without a reload, and every computed that asks isTestCustomer re-runs. Until the doc arrives (or when it is
// absent) the list is the house default ['Tester'], the same as the server's loadTestMarkers.
//
// Read-only here. The list is written only by the saveTestCustomerSettings callable (docs/features/test_customer_sweep_FEATURE.md).

import { defineStore } from 'pinia'
import { ref } from 'vue'
import { doc } from 'firebase/firestore'
import { onSnapshot } from '@/services/sessionListeners'
import { db } from '@/services/firebaseconfig'
import { setTestCustomerMarkers, testCustomerMarkers } from '@/utils/testCustomer'
import { markersFromConfig } from '../../functions-shared/utils/testCustomers'

export const useTestCustomerMarkersStore = defineStore('testCustomerMarkers', () => {
  const loaded = ref(false)
  let _unsubscribe = null

  function subscribe() {
    if (_unsubscribe?.active) return
    _unsubscribe = onSnapshot(
      doc(db, 'globalSettings', 'testCustomers'),
      snap => {
        setTestCustomerMarkers(markersFromConfig(snap.exists() ? snap.data() : null))
        loaded.value = true
      },
      error => {
        console.error('[testCustomerMarkersStore] Snapshot error:', error)
        loaded.value = true
      }
    )
  }

  function unsubscribeAll() {
    if (_unsubscribe) {
      _unsubscribe()
      _unsubscribe = null
    }
    loaded.value = false
  }

  return { markers: testCustomerMarkers, loaded, subscribe, unsubscribeAll }
})
